import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Select, MenuItem } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function TakeAction({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Take Action</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                        <div className="control_group">
                            <Select value="Pending" size="small" fullWidth >
                                <MenuItem value="Pending">Change Status of Order</MenuItem>
                                <MenuItem value="Accepted">Processed(Current)</MenuItem>
                                <MenuItem value="Rejected">Shipped</MenuItem>
                                <MenuItem value="Rejected">Delivered</MenuItem>
                            </Select>
                        </div>
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel Order and Refund Payment
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Notify Vendor To change status
                            </Button>
                        </div>
                       
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
